import { ReactNode } from 'react';
import { Box } from '@qga/roo-ui/components';

import Skeleton from '@shared/v2/components/Skeleton';

export type PriceContainerProps = {
  children: ReactNode;
};

const PriceContainer = ({ children }: PriceContainerProps) => {
  return (
    <Skeleton height="5rem">
      <Box alignSelf="flex-end">{children}</Box>
    </Skeleton>
  );
};

export default PriceContainer;
